import React, { useState, useEffect } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

const CommonModal = ({
  isOpen,
  closeModal,
  closeOnOverlayClick,
  showCloseIcon,
  children,
  classNames,
  closeOnEsc,
  animationDuration,
}) => {
  const [open, setOpen] = useState(isOpen);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => {
    setOpen(false);
    if (closeModal) {
      closeModal();
    }
  };

  useEffect(() => {
    setOpen(isOpen);
    if (isOpen)
      document.body.style.overflow = 'hidden';
    else
      document.body.style.overflow = 'unset';
  }, [isOpen]);

  return (
    <div>
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        closeOnOverlayClick={closeOnOverlayClick}
        showCloseIcon={showCloseIcon}
        classNames={classNames}
        closeOnEsc={closeOnEsc}
        animationDuration={animationDuration}
        blockScroll={false}
      >
        {children}
      </Modal>
    </div>
  );
};

export default CommonModal;
